import { render, staticRenderFns } from "./WorkerFinalReviewPullout.vue?vue&type=template&id=5b37b7fd&scoped=true&"
import script from "./WorkerFinalReviewPullout.vue?vue&type=script&lang=js&"
export * from "./WorkerFinalReviewPullout.vue?vue&type=script&lang=js&"
import style0 from "./WorkerFinalReviewPullout.vue?vue&type=style&index=0&id=5b37b7fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37b7fd",
  null
  
)

export default component.exports